
function Dashboard() {
  return (
    <div className="row gy-44">
      {/* ======================= First Row Cards Start =================== */}
      <div className="col-xxl-8 mb-20">
        <div className="row gy-3">
          <div className='col-xxl-3'>
            <div className='card h-100 p-0'>
              <div className='card-body p-24'>
                <div className='card-title mb-0 h4'>Welcome To Admin Dashboard</div>

              </div>
            </div>
          </div>
        </div>
      </div>
      
      
    </div>
  );
}

export default Dashboard;
